import { Controller } from "@hotwired/stimulus"
import { useHotkeys } from "stimulus-use"

// Add a quick hotkey shortcut to a link.
//
// Example:
//   <a
//     data-controller="hotkey-link"
//     data-hotkey-link-key-value="ctrl+a"
//     title="Admin"
//     href="/admin"
//   >
//     Admin
//   </a>
export default class extends Controller {
  static values = { key: String }

  connect() {
    useHotkeys(this, { [this.keyValue]: [this.click] })

    this.element.title = this.#title()
  }

  click() {
    this.element.dispatchEvent(new MouseEvent("click"))
  }

  #title() {
    const title = this.element.title
    const shortcut = this.#shortcut()

    return title ? `${title} (${shortcut})` : shortcut
  }

  #shortcut() {
    return this.keyValue.split("+").map(v => {
      switch (v) {
        case "cmd": return "⌘"
        case "enter": return "↩"
        default: return v
      }
    }).join(" + ")
  }
}
